'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _isURL = require('./isURL');

var _isURL2 = _interopRequireDefault(_isURL);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * This function currently only doesn `isURL` and `.indexOf('soundcloud')`.
 * 
 * ##### FIXME: write tests and make proper regex for testing soudcloud urls.
 * @memberof StringUtils
 * @function isSoundcloudURL
 * @param  {String} url to validate
 * @return {Boolean} true if url valid soundcloud url
 */
var isSoundcloudURL = function isSoundcloudURL(url) {
  return url.indexOf('soundcloud') > -1 && (0, _isURL2.default)(url);
};

exports.default = isSoundcloudURL;